export const calcEn_schema = (value, minAmount = 0, maxAmount, page) => {
    const formatNumber = (value) => {
    if (value === undefined || value === null || value === "" || isNaN(value))
      return "";
    const num = Number(String(value).replace(/,/g, ""));
    return isNaN(num) ? "" : num.toLocaleString("en-EG"); // you can change locale if needed
  };
  if (
    (maxAmount == null || maxAmount === 0)
  ) {
    return { valid: true, message: "" }; 
  }
  if (page === "manasik") {
    if (value >= minAmount && value <= maxAmount) {
      return { valid: true, message: "" };
    } else {
      return {
        valid: false,
        message: `Please enter a value between ${formatNumber(minAmount)} and ${formatNumber(maxAmount)}`,
      };
    }
  } else {
    if (value <= maxAmount) {
      return { valid: true, message: "" };
    } else {
      return {
        valid: false,
        message: `Please enter a value less than or equal to ${formatNumber(maxAmount)}`,
      };
    }
  }
};
